"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _constants = require("../../../contactcard/constants");
var _contactPickerTheme = require("../../contactPickerTheme");
const {
  neutralLight30
} = _designTokens.lodestarColors;
const OptionRoot = (0, _styled.default)("div")`
    display: block;
    border-radius: 4px;
    display: flex;
    box-sizing: border-box;
    padding: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _contactPickerTheme.contactPickerTheme.option.padding(themeMode);
}};
    margin: 0 8px;
    cursor: pointer;
    white-space: nowrap;
    background-color: ${_ref2 => {
  let {
    isHighlighted
  } = _ref2;
  return isHighlighted ? `var(--smar--sds--option--root--background, ${(0, _designTokensReact.color)("color--background--neutral--weaker", neutralLight30)})` : "transparent";
}};

    & [class*="${_constants.ccnamelabel}"] {
        // match the line-height and font-size to ensure the TypeRampV2 tooltip doesn't show.
        font-size: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _contactPickerTheme.contactPickerTheme.option.name.fontSize(themeMode);
}};
        line-height: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _contactPickerTheme.contactPickerTheme.option.name.fontSize(themeMode);
}};
        height: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _contactPickerTheme.contactPickerTheme.option.name.height(themeMode);
}};
    }

    & [class*="${_constants.ccdetailitemlabel}"] {
        // match the line-height and font-size to ensure the TypeRampV2 tooltip doesn't show.
        font-size: ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return _contactPickerTheme.contactPickerTheme.option.detailItem.fontSize(themeMode);
}};
        line-height: ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return _contactPickerTheme.contactPickerTheme.option.detailItem.fontSize(themeMode);
}};
        height: ${_ref8 => {
  let {
    themeMode
  } = _ref8;
  return _contactPickerTheme.contactPickerTheme.option.detailItem.height(themeMode);
}};
    }

    &[aria-disabled="true"] * {
        cursor: not-allowed;
    }
`;
exports.OptionRoot = OptionRoot;
//# sourceMappingURL=OptionRoot.js.map